import geoMap from '../misc/geo';
import langMap from '../misc/lang';

export default {
	app() {
		return this.$root.$children[0];
	},
	geoMap() {
		return geoMap;
	},
	langMap() {
		return langMap;
	},
	deviceIconMap() {
		return {
			desktop: 'fa fa-desktop',
			tablet: 'fa fa-tablet',
			mobile: 'fa fa-mobile',
			bot: 'fa fa-search',
			media: 'fa fa-file-video-o'
		};
	},
	filtersMap() {
		let map = {
			dates: {
				label: 'DATE_RANGE',
				key: 'dates',
				type: 'dateRange'
			},
			domain: {
				label: 'DOMAIN',
				key: 'domain',
				type: 'domain',
				icon: 'globe',
				items: this.arrayToListItems(this.app.getAvailableDomains()),
				withNot: false
			},
			page: {
				label: 'PAGE',
				key: 'page',
				type: 'text',
				icon: 'file-o',
				placeholder: '/'
			},
			source: {
				label: 'SOURCE',
				key: 'source',
				type: 'multisel',
				icon: 'mail-reply-all',
				items: this.arrayToListItems(['organic', 'social', 'ai', 'direct', 'referral', 'ads', '?'], true)
			},
			bots: {
				label: 'BOTS',
				key: 'bots',
				type: 'list',
				defaultVal: '',
				items: Object.keys(this.botsItemsMap).map(key => {
					let text = this.botsItemsMap[key];
					return { key, text };
				})
			},
			referrer: {
				label: 'REFERRER',
				key: 'referrer',
				type: 'multisel',
				icon: 'reply',
				items: this.arrayToListItems(this.app.distinctValues.referrer)
			},
			userId: {
				label: 'USER_ID',
				key: 'userId',
				type: 'text',
				icon: 'user'
			},
			phrase: {
				label: 'SEARCH_PHRASE',
				key: 'phrase',
				type: 'text',
				icon: 'search'
			},
			geo: {
				label: 'COUNTRY',
				key: 'geo',
				type: 'multisel',
				icon: 'flag',
				items: this.getGeoItems(),
				withNot: 1
			},
			lang: {
				label: 'LANGUAGE',
				key: 'lang',
				type: 'multisel',
				icon: 'language',
				items: this.getLangItems()
			},
			browser: {
				label: 'BROWSER',
				key: 'browser',
				type: 'multisel',
				icon: 'chrome',
				items: this.arrayToListItems(this.app.distinctValues.browser)
			},
			os: {
				label: 'OS',
				key: 'os',
				type: 'multisel',
				icon: 'linux',
				items: this.arrayToListItems(this.app.distinctValues.os)
			},
			vendor: {
				label: 'VENDOR',
				key: 'vendor',
				type: 'multisel',
				icon: 'wrench',
				items: this.arrayToListItems(this.app.distinctValues.vendor)
			},
			device: {
				label: 'DEVICE',
				key: 'device',
				type: 'multisel',
				icon: 'desktop',
				items: this.arrayToListItems(this.app.distinctValues.device, true)
			},
			custom: {
				label: 'CUSTOM',
				key: 'custom',
				type: 'multisel',
				icon: 'cogs',
				disabled: !this.checkFeature('filter:custom'),
				items: [
					{key: 'shb', val: 'Sharebutton'},
					{key: 'shb2', val: 'JS domains'},
					{key: 'seo_article', val: 'SEO article'}
				]
			},
			ip: {
				label: 'IP',
				key: 'ip',
				type: 'lists',
				icon: 'map-marker',
				whiteLabel: this.ii('INCLUDE_IPS'),
				blackLabel: this.ii('EXCLUDE_IPS'),
			},
			/*recorded: {
				label: 'RECORDED',
				key: 'recorded',
				type: 'checkbox',
				icon: 'play'
			},*/
			session: {
				label: 'SESSION',
				key: 'session',
				type: 'text',
				hidden: true
			}
		};
		return map;
	},
	botsItemsMap() {
		return {
			'': this.ii('EXCLUDE_BOTS'),
			'include': this.ii('INCLUDE_BOTS'),
			'only': this.ii('ONLY_BOTS')
		};
	}
};
